// removed by extract-text-webpack-plugin
module.exports = {"cardSelector":"styles__cardSelector__p8RRw","active":"styles__active__2PXWE","cardImage":"styles__cardImage__3B_2o","cardText":"styles__cardText__2yqlb","front":"styles__front__1_i_A","hover":"styles__hover__3G05M","back":"styles__back__3abDO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupCard/styles.scss
// module id = 411
// module chunks = 0